import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, State } from './types';

export const useAppDispatch = useDispatch.withTypes<Dispatch>();
export const useAppSelector = useSelector.withTypes<State>();
